export class InaSchoolEnrollment {
    Id: number;
    StudentId: number;
    SchoolEnrollmentId: number;
    StatusTypeId: number;
    TermDurationId: number;
    EnrollmentType: string;
    GradeId: number;
    Grade: string;
    SchoolYearId: number;
    SchoolYear: string;
    SchoolLookUpId: number;
    RegionId: number;
    RegionName: string;
    DistrictId: number;
    DistrictName: string;
    SchoolId: number;
    SchoolName: string;
    CreatedBy: string;
    CreatedDate: Date;
    ModifiedBy: string;
    ModifiedDate: Date;
    FollowUpName: any;
    FollowUpDate: string;
}

export class EditableInaSchoolEnrollment {
    isEdit: boolean;
    isDelete?: boolean = false;
    inaSchoolEnrollment: InaSchoolEnrollment;
}
